import { create } from 'zustand';

export type PrimaryBannerSlot = 'free' | 'none' | 'occupied';

type BannerSlotStore = {
  primary: PrimaryBannerSlot;
};

export const useBannerSlotStore = create<BannerSlotStore>(() => ({ primary: 'none' }));
